import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { Autocomplete, Button, Checkbox, Dialog, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, Grid, InputAdornment, InputLabel, List, MenuItem, OutlinedInput, Paper, Skeleton, Stack, Tooltip,Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, TextareaAutosize, AppBar, Tabs, Tab, Typography, Select } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import NoDataPlaceholder from 'app/shared/NoDataPlaceholder';
import SalesOverview from 'app/shared/metrics/SalesOverview';
import UserOrders from 'app/shared/metrics/UserOrders';
import Documents1 from 'app/shared/widgets/Documents1';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import Ideas1 from 'app/shared/widgets/Ideas1';
import DiamondIcon from '@mui/icons-material/Diamond';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import * as yup from "yup";
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import UserSummary from 'app/shared/widgets/UserSummary';
import React, { useCallback, useEffect, useState } from 'react';
import UserProfileCard1 from 'app/shared/widgets/UserProfileCard1';
import { DataGrid } from '@mui/x-data-grid';
import { isMobileDevice } from 'app/utils/modifyArrayOfObjectsKeys';
import { formatDate } from '../partStoneStatus/partStoneStatus';
import JumboCardFeatured from '@jumbo/components/JumboCardFeatured';
import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import FeedItem from 'app/shared/widgets/DailyFeed/FeedItem';
import styled from '@emotion/styled';
import { number } from 'prop-types';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { LoadingButton } from '@mui/lab';
import JumboAppTextField from '@jumbo/components/JumboAppTextField';
import { useParams } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import Div from '@jumbo/shared/Div';
import SwipeableViews from 'react-swipeable-views';
const validationSchema = yup.object({
  term: yup.string().required('Term is required'),
  PARTY: yup.string().required('Please Select Party'),
})
const PartyPayment = ({FRMVAL}) => {
  const [value, setValue] = React.useState({bank:null,FL_CURR_CODE:2,date:null,Rate:null,narration:'',partyID:null});
  const [invoiceData, setinvoiceData] = React.useState(null);
  const [invoiceDataForUpdate, setinvoiceDataForUpdate] = React.useState(null);
  const [expdetRow, setExpdetRow] = useState([{ ledgername: null, description: '', debitAmount: '' },{ ledgername: null, description: '', debitAmount: '' },{ ledgername: null, description: '', debitAmount: '' }]);
  const [selectedinvoiceData, setSelectedinvoiceData] = React.useState(null);
  const [invoicePaidAMT, setinvoicePaidAMT] = React.useState({});
  const [currdata,setcurrdata]=useState([])
  const [selecedsummrydata,setSelecedsummrydata]=useState({})
  const [sumDetailsData,setSumDetailsData]=useState({})
  const [helperdata,sethelperdata]=useState({})
  const isMobile = isMobileDevice();
  const jumboco = useJumboAuth();
  const swal = useSwalWrapper();
  const {PID} = useParams();
  const init = async ()=>{
    await jwtAuthAxios.post('/acc/getleadgerdetail',{frno:[4,5],tono:[21,22],grpno:'4' }).then(res=>{
      sethelperdata(res.data)
    }).catch(e=>{
      swal.fire({
        icon:"error",
        text:e
      })
    })
    await jwtAuthAxios.get('master/helper?curr=1',{frno:[24],tono:[21,22]}).then(RESDATA=>{
      setcurrdata(RESDATA.data.data.CURR)
    }).catch(e=>{
      swal.fire({
        icon:"error",
        text:e
      })
    })
    // PID&&  await jwtAuthAxios.get(`acc/getentrydetails?no=${PID}&type=P`).then(async res => {
    //   // setValue({bank:res,FL_CURR_CODE:2,date:null,Rate:null,narration:'',partyID:null})
    // })
  }
  useEffect(()=>{
    init()
  },[])
  useEffect(()=>{
    setValue({...value,Rate:jumboco?.curr?.Rate})
  },[jumboco?.curr])
  const fetchPartyInvoice = useCallback(async()=>{if(value?.partyID){
    setinvoiceData([])
    setSelectedinvoiceData(null)
    !FRMVAL && setinvoicePaidAMT({})
     await jwtAuthAxios.get('/acc/getpartypurchaseinvoice?party='+value?.partyID.P_CODE+'&curr='+value?.FL_CURR_CODE).then(res=>{
      setinvoiceData(res.data?.data)
    }).catch(e=>{
      setinvoiceData(null)
      setSelectedinvoiceData(null)
      swal.fire({
        icon:"error",
        text:e
      })
    })}},[value?.partyID,value?.FL_CURR_CODE])
  useEffect(async()=>{
    value?.partyID && value?.FL_CURR_CODE && fetchPartyInvoice()
  },[value?.partyID,value?.FL_CURR_CODE])
  const handleExpdetAddRow = () => {
    setExpdetRow([...expdetRow, { ledgername: null, description: '', debitAmount: '' ,TYPE:"NEW"}]);
  };
  const handleExpdetRemoveRow = (index) => {
    const updatedexpdetRow = [...expdetRow];
    updatedexpdetRow.splice(index, 1);
    setExpdetRow(updatedexpdetRow);
  };
  console.log(invoiceDataForUpdate);
  useEffect(async()=>{
let totalAMT= (invoiceDataForUpdate || invoiceData)&& (invoiceDataForUpdate || invoiceData)?.reduce((acc, obj) => acc + Number(obj.FFL_AMT2), 0)
let totalPaidAmt= (invoiceDataForUpdate || invoiceData)&& (invoiceDataForUpdate|| invoiceData)?.reduce((acc, obj) => acc + Number(obj.PAID_BILL), 0)
// console.log(totalAMT,totalPaidAmt);
    setSumDetailsData({...sumDetailsData,totalAMT,totalPaidAmt})
  },[invoiceDataForUpdate,invoiceData,invoicePaidAMT])
  useEffect(async()=>{
    let TotalPaidamtin =0
    let totalAMTPaidAmt= Object.keys(invoicePaidAMT).map(s=>{
      TotalPaidamtin+=Number(invoicePaidAMT[s]?.paid_amt)
    })
    setSumDetailsData({...sumDetailsData,TotalPaidamtin})
    // setSumDetailsData({...sumDetailsData})
  },[invoicePaidAMT])
  // console.log(sumDetailsData);
  // useEffect(async()=>{
  //   if(value?.partyID){
  //   setinvoiceData([])
  //   setSelectedinvoiceData(null)
  //    await jwtAuthAxios.get('/acc/getpartypurchaseinvoice?party='+value?.partyID.P_CODE).then(res=>{
  //     setinvoiceData(res.data?.data)
  //   }).catch(e=>{
  //     setinvoiceData(null)
  //     setSelectedinvoiceData(null)
  //     swal.fire({
  //       icon:"error",
  //       text:e
  //     })
  //   })}
  // },[value?.partyID])
  // const handlePaymentValidaiton= async  ()=>{
  //   //alert('ok')
  //   let err=false;
  //   if(Object.keys(invoicePaidAMT).filter(s=>(invoicePaidAMT[s].paid_amt && invoicePaidAMT[s].paid_amt >0)||invoicePaidAMT[s]?.close_bill).length < 1){
  //     err=true;
  //     alert('Please Enter Bill Data')
  //     return
  //   }
  //   let UPDOBJ= selectedinvoiceData?.map(sInData=>{
  //     let newObj = {...invoicePaidAMT[`amt_paid_bill${sInData?.FL_BILL_NO}`],...sInData}
  //     if((Math.ceil(newObj?.paid_amt) <= Math.ceil(sInData?.FFL_AMT2)) && (newObj?.paid_amt > 0)){
  //     } else {
  //       err=true;
  //       setinvoicePaidAMT({...invoicePaidAMT,[`amt_paid_bill${sInData?.FL_BILL_NO}`]:{paid_amt:newObj?.paid_amt,err:true,hTEXT:"Invalid Amount"}})
  //     }
  //     return newObj
  //   })
  //   value?.bank == null ? setSelecedsummrydata({...selecedsummrydata,bank:{err:true,msg:'Please Enter Bank Details'}}) : setSelecedsummrydata({...selecedsummrydata,bank:{err:false,msg:''}})
  //   value?.partyID == null ? setSelecedsummrydata({...selecedsummrydata,partyID:{err:true,msg:'Please Enter Party Details'}}) : setSelecedsummrydata({...selecedsummrydata,partyID:{err:false,msg:''}})
  //   value?.date == null ? setSelecedsummrydata({...selecedsummrydata,date:{err:true,msg:'Please Select Date'}}) : setSelecedsummrydata({...selecedsummrydata,date:{err:false,msg:''}})

  //   if(err == false){
  //     jwtAuthAxios.post(`acc/paymentreceive`,{...value,DRAC:value?.bank.ACODE,CRAC:value?.partyID.ACODE,rate:value?.Rate ||jumboco?.curr?.Rate,DET_DATA:UPDOBJ,TYPE:"P"}).then((res) => {
  //       swal.fire({
  //         icon: 'success',
  //         text: res.data.message,
  //       });
  //     }).catch(e => {
  //       swal.fire({
  //         icon: 'error',
  //         text: 'Internal server Error',
  //       });
  //     })
  //   }    
  // }
  useEffect(() => {
    FRMVAL && setValue({ bank: FRMVAL?.CRAC, date: FRMVAL?.master?.FL_TRANS_DATE.split('T')[0], FL_CURR_CODE: FRMVAL?.master?.FL_CURRENCY, Rate: FRMVAL?.master?.FL_CONV_RATE, narration:FRMVAL?.master?.FL_NARRATION || '', partyID: FRMVAL?.DRAC })
    let tmpobj ={}
    FRMVAL?.detailsEntry.forEach(o => {
      tmpobj[`amt_paid_bill${o.FL_BILL_NO}`]= {paid_amt: Number(o.PAID_AMT || 0)?.toFixed(2)}
    })
    setinvoicePaidAMT(tmpobj);
      // ({})) 
    FRMVAL && setinvoiceDataForUpdate(FRMVAL?.detailsEntry?.map(ida=>({...ida,PAID_BILL:(ida.PAID_BILL-ida.PAID_AMT)?.toFixed(2),type:'update'})))
    let expdata = FRMVAL?.details.filter(sd=> !sd.FL_REF_TRANSNO && !sd.FL_REF_TRANSTYPE)
    FRMVAL && setExpdetRow(expdata.map(s=>({ ledgername: s.FL_DR_AC, description: s?.FL_DESCRIPTION, debitAmount: s?.FL_AMT2 })))
  }, [FRMVAL])
  const handlePaymentValidaiton= async  ()=>{
    //alert('ok')
    let err=false;
    if(Object.keys(invoicePaidAMT).filter(s=>(invoicePaidAMT[s].paid_amt && invoicePaidAMT[s].paid_amt >0)||invoicePaidAMT[s]?.close_bill).length < 1){
      err=true;
      alert('Please Enter Bill Data')
      return
    }
    let UPDOBJ= (invoiceDataForUpdate || invoiceData)?.map(sInData=>{
      let newObj = {...invoicePaidAMT[`amt_paid_bill${sInData?.FL_BILL_NO}`],...sInData}
      // if((Math.ceil(newObj?.paid_amt) <= Math.ceil(sInData?.FFL_AMT2)) && (newObj?.paid_amt > 0)){
      // } else {
      //   err=true;
      //   setinvoicePaidAMT({...invoicePaidAMT,[`amt_paid_bill${sInData?.FL_BILL_NO}`]:{paid_amt:newObj?.paid_amt,err:true,hTEXT:"Invalid Amount"}})
      // }
      if(((sInData?.FFL_AMT2 - (sInData?.PAID_BILL)) - (invoicePaidAMT['amt_paid_bill' + sInData?.FL_BILL_NO]?.paid_amt || 0))?.toFixed(2) < 0){
        err=true;
        alert(sInData?.FL_BILL_NO+' Bill AMT is invalid')
      }
      return newObj
    })
    value?.bank == null ? setSelecedsummrydata({...selecedsummrydata,bank:{err:true,msg:'Please Enter Bank Details'}}) : setSelecedsummrydata({...selecedsummrydata,bank:{err:false,msg:''}})
    value?.partyID == null ? setSelecedsummrydata({...selecedsummrydata,partyID:{err:true,msg:'Please Enter Party Details'}}) : setSelecedsummrydata({...selecedsummrydata,partyID:{err:false,msg:''}})
    value?.date == null ? setSelecedsummrydata({...selecedsummrydata,date:{err:true,msg:'Please Select Date'}}) : setSelecedsummrydata({...selecedsummrydata,date:{err:false,msg:''}})

    if(err == false){
      if(FRMVAL){
        jwtAuthAxios.post(`acc/paymentreceive/P/${FRMVAL?.master?.FL_TRANSNO}`, { ...value, ...value,PR_TYPE:'P',CRAC:value?.bank.ACODE,DRAC:value?.partyID.ACODE,rate:value?.Rate ||jumboco?.curr?.Rate, DET_DATA: UPDOBJ.filter(sd => (sd.paid_amt && sd.paid_amt > 0) || sd?.close_bill || sd?.type=='update'), TYPE: "P",expdetRow:expdetRow }).then((res) => {
          fetchPartyInvoice()
          swal.fire({
            icon: 'success',
            text: res.data.message,
          });
        }).catch(e => {
          swal.fire({
            icon: 'error',
            text: 'Internal server Error',
          });
        })
      } else{
      jwtAuthAxios.post(`acc/paymentreceive`,{...value,CRAC:value?.bank.ACODE,DRAC:value?.partyID.ACODE,rate:value?.Rate ||jumboco?.curr?.Rate,DET_DATA:UPDOBJ.filter(sd=> (sd.paid_amt && sd.paid_amt >0)||sd?.close_bill),TYPE: "P",PR_TYPE:'P',expdetRow:expdetRow}).then((res) => {
        fetchPartyInvoice()
        swal.fire({
          icon: 'success',
          text: res.data.message,
        });
      }).catch(e => {
        swal.fire({
          icon: 'error',
          text: 'Internal server Error',
        });
      })
    }
    }
    
    
  }
  return (<>
   
                  <Grid container spacing={2}>
                    <Grid item lg={5} xs={12}>
                    <FormControl fullWidth error={selecedsummrydata?.bank?.err} helperText={selecedsummrydata?.bank?.msg}>
                        <Autocomplete
                          value={value?.bank}
                          fullWidth
                          onChange={(event, newValue) => {
                            setValue({...value,bank:newValue});
                          }}
                          sx={{p:0}}
                          options={helperdata?.toData || []}
                          getOptionLabel={(option) => option?.ANAME || ''} // Specify the property to use as the display value
                          renderInput={(params) => (
                            <TextField {...params}  label="Please Select Bank" />
                          )}
                        />
                        </FormControl>
                      
                    </Grid>
                    <Grid item lg={4} xs={12}>
                    <TextField  fullWidth sx={{px:1}} error={selecedsummrydata?.date?.err} helperText={selecedsummrydata?.date?.msg} type='date' name={'date'} onChange={e=>setValue({...value,date:e.target.value})} value={value?.date || ''} variant="outlined"/>
                    </Grid>
                    {/* <Grid item lg={1.5} xs={12}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="outlined-adornment-amount">Conversion Rate</InputLabel>
                        <OutlinedInput
                            // value={values.amount}
                            onChange={(e)=>setValue({...value,Rate:e.target.value > 0 ? e.target.value : null})}
                            type='number'
                            startAdornment={<InputAdornment position="start">{jumboco?.curr?.cd}</InputAdornment>}
                            value={value.Rate || jumboco?.curr?.Rate}
                            label="Conversion Rate"
                        />
                    </FormControl>
                    </Grid> */}
                    <Grid item lg={1.5} xs={12}>
                    <FormControl 
  name="FL_CURR_CODE" 
  disabled={FRMVAL} // Disabling based on FRMVAL condition
  // size="small" 
  fullWidth
>
  <InputLabel id="FL_CURR_CODE-label">Currency Type</InputLabel>
  <Select
    labelId="FL_CURR_CODE-label"
    id="FL_CURR_CODE"
    name="FL_CURR_CODE"
    value={value?.FL_CURR_CODE}
    onChange={e => setValue({ ...value, FL_CURR_CODE: e.target.value })}
    label="Currency Type"
    fullWidth
  >
    {currdata?.map((option) => (
      <MenuItem key={option.FL_CURRENCY_ID} value={option.FL_CURRENCY_ID}>
        {option.FL_CURRENCY_NAME}
      </MenuItem>
    ))}
  </Select>
</FormControl>
                    {/* <ButtonGroup variant="outlined"> */}
                    {/* <FormControl name="FL_CURR_CODE" size="small"  onChange={e=>setValue({...value,FL_CURR_CODE:e.target.value})} value={value?.FL_CURR_CODE} as={TextField} select label="Currency Type" fullWidth>
                      {currdata?.map((option) => (
                        <MenuItem key={option.FL_CURRENCY_ID} value={option.FL_CURRENCY_ID}>
                          {option.FL_CURRENCY_NAME}
                        </MenuItem>
                      ))}
                    </FormControl> */}
                    </Grid>
                    <Grid item lg={1.5} xs={12}>
                    <FormControl fullWidth>
                        {/* <InputLabel  htmlFor="outlined-adornment-amount">Conversion Rate</InputLabel> */}
                        <TextField 
                            // value={values.amount}
                            onChange={(e)=>setValue({...value,Rate:e.target.value > 0 ? e.target.value : null})}
                            type='number'
                            InputLabelProps={{ shrink: true }}
                            // startAdornment={<InputAdornment position="start">{jumboco?.curr?.cd}</InputAdornment>}
                            value={value.Rate}
                            label="Conversion Rate"
                        />
                    </FormControl>
                    {/* </ButtonGroup> */}

                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <Autocomplete
                          value={value?.partyID}
                          fullWidth
                          onChange={(event, newValue) => {
                            setValue({...value,partyID:newValue});
                          }}
                          disabled={FRMVAL}
                          options={helperdata?.fromData ||[]}
                          getOptionLabel={(option) => option?.ANAME || ''} // Specify the property to use as the display value
                          renderInput={(params) => (
                            <TextField {...params} label="Please Select Party" />
                          )}
                        />
                          
                    </Grid>
                    {FRMVAL && invoiceData?.length > 0 && <Grid item lg={6} xs={12}>
                    <Button variant='outlined' onClick={e=>{ let tma = invoiceDataForUpdate.map(s=>s.FL_BILL_NO);
                      setinvoiceDataForUpdate([...invoiceDataForUpdate,...invoiceData.filter(o=>!tma.includes(o.FL_BILL_NO)).map(s=> ({...s,type:'newadd'}))]);e.target.remove();}} size='large' sx={{display:'block',ml:'auto',mt:1}}>Add New Bills</Button>
                  </Grid>}
                    {/* <Grid item lg={6} xs={12}>
                      {Array.isArray(invoiceData) ?
                        <Autocomplete
                          value={selectedinvoiceData || []}
                          fullWidth
                          multiple
                          onChange={(event, newValue) => {
                            setSelectedinvoiceData(newValue);
                          }}
                          id="Select-bill-demo"
                          options={invoiceData}
                          getOptionLabel={(option) => option?.FL_BILL_NO || ''} // Specify the property to use as the display value
                          renderInput={(params) => (
                            <TextField {...params} label="Select Bill" />
                          )}
                        /> : invoiceData != null? <Skeleton height={60} />:null}
                    </Grid> */}
                  
                  </Grid>
                  {/* </Form> */}

                  {(invoiceDataForUpdate || invoiceData)?.length > 0 && <TableContainer>
                    <Table  border={1} size='small' sx={{mt:2}}>
                      <TableHead>
                        <TableRow >
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Date</TableCell>
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}} >Invoice No</TableCell>
                          {/* <TableCell >Pcs</TableCell> */}
                          {/* <TableCell >Cts</TableCell> */}
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Currency</TableCell>
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Conv Rate</TableCell>
                          {/* <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Total AMT($)</TableCell> */}
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Total AMT</TableCell>
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Paid AMT</TableCell>
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>AMT</TableCell>
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Due AMT</TableCell>
                          {/* {invoiceData[0]?.FL_CURR_CODE != value?.FL_CURR_CODE && <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Ex Diff</TableCell>} */}
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Close Bill</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                     {(invoiceDataForUpdate || invoiceData)?.map(indat => <TableRow key={indat?.FL_BILL_NO}>
                          <TableCell >{formatDate(indat?.FL_TRANS_DATE)}</TableCell>
                          <TableCell >{indat?.FL_BILL_NO}</TableCell>
                          {/* <TableCell >{indat?.PCS}</TableCell> */}
                          {/* <TableCell >{indat?.CTS}</TableCell> */}
                          <TableCell >{indat?.CURR}</TableCell>
                          <TableCell >{indat?.FL_CONV_RATE}</TableCell>
                          {/* <TableCell >{indat?.FFL_AMT1?.toFixed(2)}</TableCell> */}
                          <TableCell >{indat?.FFL_AMT2?.toFixed(2)}</TableCell>
                          <TableCell >{indat?.PAID_BILL}</TableCell>
                          <TableCell sx={{p:0}} >
                            {/* <TextField error={invoicePaidAMT['amt_paid_bill'+indat?.FL_BILL_NO]?.err} helperText=
                            {invoicePaidAMT['amt_paid_bill'+indat?.FL_BILL_NO]?.hTEXT || ''} fullWidth sx={{px:1,border:0}} type='number' inputProps={{ min: 0, max: Math.ceil(indat?.FFL_AMT2-indat?.PAID_BILL) }}  name={'amt_paid_bill'+indat?.FL_BILL_NO} onChange={e=>{Math.ceil(e.target.value) <= Math.ceil(indat?.FFL_AMT2-indat?.PAID_BILL) ? setinvoicePaidAMT({...invoicePaidAMT,[e.target.name]:{paid_amt:e.target.value}}):setinvoicePaidAMT({...invoicePaidAMT,[e.target.name]:{paid_amt:(indat?.FFL_AMT2-indat?.PAID_BILL).toFixed(2)}})}} value={invoicePaidAMT['amt_paid_bill'+indat?.FL_BILL_NO]?.paid_amt || 0} variant="standard"/> */}
                              <TextField fullWidth sx={{ px: 1, border: 0 }} type='number' inputProps={{ min: 0, max: Math.ceil(indat?.FFL_AMT2 - indat?.PAID_BILL) }} name={'amt_paid_bill' + indat?.FL_BILL_NO} onChange={e => { Math.ceil(e.target.value) <= Math.ceil(indat?.FFL_AMT2) ? setinvoicePaidAMT({ ...invoicePaidAMT, [e.target.name]: { paid_amt: e.target.value } }) : setinvoicePaidAMT({ ...invoicePaidAMT, [e.target.name]: { paid_amt: indat?.FFL_AMT2 - indat?.PAID_BILL } }) }} value={invoicePaidAMT['amt_paid_bill' + indat?.FL_BILL_NO]?.paid_amt || ''} variant="standard" />
                          </TableCell>
                          <TableCell >{((indat?.FFL_AMT2 - (indat?.PAID_BILL)) - (invoicePaidAMT['amt_paid_bill'+indat?.FL_BILL_NO]?.paid_amt || 0))?.toFixed(2)}</TableCell>
                          {/* {invoiceData[0]?.FL_CURR_CODE != value?.FL_CURR_CODE &&  <TableCell >{((value.Rate || jumboco?.curr?.Rate)- indat?.FL_CONV_RATE)?.toFixed(2)}</TableCell>} */}
                        <TableCell>
                          <Tooltip title={`Due AMT is (${((indat?.FFL_AMT2 - (indat?.PAID_BILL)) - (invoicePaidAMT['amt_paid_bill'+indat?.FL_BILL_NO]?.paid_amt || 0))?.toFixed(2)})`}>
                            <Checkbox  name={'amt_paid_bill'+indat?.FL_BILL_NO} onClick={e=>setinvoicePaidAMT({...invoicePaidAMT,[e.target.name]:{...invoicePaidAMT[e.target.name],close_bill:e.target.checked}})} sx={{padding: '0',display: 'block',margin: '0 auto',width: 'fit-content'}}/>
                          </Tooltip>
                          </TableCell>
                        </TableRow>)}
                         <TableRow>
                          <TableCell colSpan={4}>Total</TableCell>
                          <TableCell>{sumDetailsData?.totalAMT?.toFixed(2)}</TableCell>
                          <TableCell>{sumDetailsData?.totalPaidAmt?.toFixed(2)}</TableCell>
                          <TableCell>{sumDetailsData?.TotalPaidamtin?.toFixed(2)}</TableCell>
                          <TableCell>{(sumDetailsData?.totalAMT-sumDetailsData?.totalPaidAmt-sumDetailsData?.TotalPaidamtin)?.toFixed(2)}</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>}
                  <Stack direction='row' justifyContent={'space-between'} mb={1} mt={4}>
          <Typography variant={"h5"} >Other Charges</Typography>
          <Button size='small' variant="contained" onClick={handleExpdetAddRow}>Add New Charges</Button>
          </Stack>
          <Divider sx={{mb:2}}/>
          <Table border={0}>
            {expdetRow.map((row, index) => (
              // <React.Fragment key={index}>
              <TableRow>
              <TableCell sx={{p:0}}>
                {/* <Grid item xs={4}> */}
                  {/* <FormControl fullWidth>
                    <Autocomplete
                      // value={row.ACODE || '`'}
                      size='small'
                      sx={{minWidth:'200px'}}
                      options={helperdata?.grpleadgerAll ||[]}
                      getOptionLabel={(option) => option?.ANAME || ''}
                      value={row?.ledgername}
                      onChange={(event, newValue) => {
                        const updatedRows = [...expdetRow];
                        updatedRows[index].ledgername = newValue || '';
                        setExpdetRow(updatedRows);
                      }}
                      renderInput={(params) => <TextField {...params} label="Debit Ledger Name" />}
                    />
                  </FormControl> */}
                  
              <FormControl fullWidth>
                <InputLabel id="ledgername-label" size='small'>Debit Ledger Name</InputLabel>
                <Select
                  labelId="ledgername-label"
                  id="ledgername"
                  value={row.ledgername || ''}
                  onChange={(event) => {
                    const updatedRows = [...expdetRow];
                    updatedRows[index].ledgername = event.target.value || '';
                    setExpdetRow(updatedRows);
                  }}
                  label="Debit Ledger Name"
                  size="small"
                  sx={{ minWidth: '200px' }}
                >
                  {helperdata?.grpleadgerAll?.map((option) => (
                    <MenuItem key={option?.ACODE} value={option?.ACODE}>
                      {option?.ANAME}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
                {/* </Grid> */}
                </TableCell>
                <TableCell sx={{p:1}}>
                {/* <Grid item xs={4}> */}
                  <TextField
                    fullWidth
                    size='small'
                    value={row.description}
                    onChange={(event) => {
                      const updatedRows = [...expdetRow];
                      updatedRows[index].description = event.target.value;
                      setExpdetRow(updatedRows);
                    }}
                    label="Description"
                  />
                {/* </Grid>
                <Grid item xs={3}> */}
                </TableCell>
                <TableCell sx={{p:0}}>
                  <TextField
                    fullWidth
                    size='small'
                    value={row.debitAmount}
                    onChange={(event) => {
                      const updatedRows = [...expdetRow];
                      updatedRows[index].debitAmount = event.target.value;
                      setExpdetRow(updatedRows);
                    }}
                    inputProps={{ min: 1 }} 
                    type='number'
                    label={`Debit Amount`}
                  />
                {/* </Grid>
                <Grid item xs={1}> */}
                </TableCell>
                {/* <TableCell sx={{p:0,textAlign: 'end'}} >
                  <Tooltip title="Remove"><Fab color='error' variant="contained" onClick={() => handleRemoveRow(index)} size='small'><DeleteOutlineOutlinedIcon /></Fab>
                  </Tooltip>
                </TableCell> */}
                {/* </Grid> */}
                </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={2}><Typography variant={"h4"} >Total</Typography></TableCell>
              {expdetRow?.reduce((acc, obj) => acc + Number(obj.debitAmount), 0)}
            </TableRow>
            </Table>
                  <TextareaAutosize minRows={5} onInput={e=>setValue({...value,[e.target.name]:e.target.value})} name='narration' placeholder='NARRATION'defaultValue={value['narration']} style={{width:'100%',marginTop:'50px'}}></TextareaAutosize>
                  <LoadingButton disabled={(value.bank == null || value.partyID == null || value.date == null)  } onClick={handlePaymentValidaiton} variant="contained" sx={{mt:2,ml:'auto',display: 'block'}}>
                    Make Payment
                  </LoadingButton>
      </>
  )
};
const ExpensePayment = ({FRMVAL}) => {
  const [value, setValue] = React.useState({bank:null,FL_CURR_CODE:2,date:null,Rate:null,narration:'',partyID:null});
  const [invoiceData, setinvoiceData] = React.useState(null);
  const [selectedinvoiceData, setSelectedinvoiceData] = React.useState(null);
  const [invoicePaidAMT, setinvoicePaidAMT] = React.useState({});
  const [invoiceDataForUpdate, setinvoiceDataForUpdate] = React.useState(null);

    const [currdata,setcurrdata]=useState([])
  const [selecedsummrydata,setSelecedsummrydata]=useState({})
  const [helperdata,sethelperdata]=useState({})
  const isMobile = isMobileDevice();
  const jumboco = useJumboAuth();
  const swal = useSwalWrapper();
  const {PID} = useParams();
  const init = async ()=>{
    await jwtAuthAxios.post('/acc/getleadgerdetail',{frno:[185],tono:[21,22]}).then(res=>{
      sethelperdata(res.data)
    }).catch(e=>{
      swal.fire({
        icon:"error",
        text:e
      })
    })
    await jwtAuthAxios.get('master/helper?curr=1').then(RESDATA=>{
      setcurrdata(RESDATA.data.data.CURR)
    }).catch(e=>{
      swal.fire({
        icon:"error",
        text:e
      })
    })
    // PID&&  await jwtAuthAxios.get(`acc/getentrydetails?no=${PID}&type=P`).then(async res => {
    //   // setValue({bank:res,FL_CURR_CODE:2,date:null,Rate:null,narration:'',partyID:null})
    // })
  }
  useEffect(()=>{
    init()
  },[])
  useEffect(()=>{
    setValue({...value,Rate:jumboco?.curr?.Rate})
  },[jumboco?.curr])
  const fetchPartyInvoice = useCallback(async()=>{if(value?.partyID){
    setinvoiceData([])
    setSelectedinvoiceData(null)
    !FRMVAL && setinvoicePaidAMT({})
    value?.date && value?.partyID && await jwtAuthAxios.get('/acc/getExpenseInvoice?pid='+value?.partyID.ACODE +'&curr='+value?.FL_CURR_CODE+'&date='+value?.date ).then(res=>{
      setinvoiceData(res.data?.data)
    }).catch(e=>{
      setinvoiceData(null)
      setSelectedinvoiceData(null)
      swal.fire({
        icon:"error",
        text:e
      })
    })}},[value?.partyID,value?.FL_CURR_CODE,value?.date])
  useEffect(async()=>{
    fetchPartyInvoice()
  },[value?.partyID,value?.FL_CURR_CODE,value?.date])
  useEffect(() => {
    FRMVAL && setValue({ partyID: FRMVAL?.DRAC, date: FRMVAL?.master?.FL_TRANS_DATE.split('T')[0], FL_CURR_CODE: 2, Rate: jumboco?.curr?.Rate, narration: FRMVAL?.master?.FL_NARRATION || '', bank: FRMVAL?.CRAC })
    let tmpobj ={}
    FRMVAL?.detailsEntry.forEach(o => {
      tmpobj[`amt_paid_bill${o.FL_BILL_NO}`]= {paid_amt: Number(o.PAID_AMT || 0)?.toFixed(2)}
    })
    setinvoicePaidAMT(tmpobj);
      // ({})) 
    FRMVAL && setinvoiceDataForUpdate(FRMVAL?.detailsEntry.map(ida=>({...ida,PAID_BILL:(ida.PAID_BILL-ida.PAID_AMT)?.toFixed(2)})))
  }, [FRMVAL])

  // useEffect(async()=>{
  //   if(value?.partyID){
  //   setinvoiceData([])
  //   setSelectedinvoiceData(null)
  //    await jwtAuthAxios.get('/acc/getpartypurchaseinvoice?party='+value?.partyID.P_CODE).then(res=>{
  //     setinvoiceData(res.data?.data)
  //   }).catch(e=>{
  //     setinvoiceData(null)
  //     setSelectedinvoiceData(null)
  //     swal.fire({
  //       icon:"error",
  //       text:e
  //     })
  //   })}
  // },[value?.partyID])
  // const handlePaymentValidaiton= async  ()=>{
  //   //alert('ok')
  //   let err=false;
  //   if(Object.keys(invoicePaidAMT).filter(s=>(invoicePaidAMT[s].paid_amt && invoicePaidAMT[s].paid_amt >0)||invoicePaidAMT[s]?.close_bill).length < 1){
  //     err=true;
  //     alert('Please Enter Bill Data')
  //     return
  //   }
  //   let UPDOBJ= selectedinvoiceData?.map(sInData=>{
  //     let newObj = {...invoicePaidAMT[`amt_paid_bill${sInData?.FL_BILL_NO}`],...sInData}
  //     if((Math.ceil(newObj?.paid_amt) <= Math.ceil(sInData?.FFL_AMT2)) && (newObj?.paid_amt > 0)){
  //     } else {
  //       err=true;
  //       setinvoicePaidAMT({...invoicePaidAMT,[`amt_paid_bill${sInData?.FL_BILL_NO}`]:{paid_amt:newObj?.paid_amt,err:true,hTEXT:"Invalid Amount"}})
  //     }
  //     return newObj
  //   })
  //   value?.bank == null ? setSelecedsummrydata({...selecedsummrydata,bank:{err:true,msg:'Please Enter Bank Details'}}) : setSelecedsummrydata({...selecedsummrydata,bank:{err:false,msg:''}})
  //   value?.partyID == null ? setSelecedsummrydata({...selecedsummrydata,partyID:{err:true,msg:'Please Enter Party Details'}}) : setSelecedsummrydata({...selecedsummrydata,partyID:{err:false,msg:''}})
  //   value?.date == null ? setSelecedsummrydata({...selecedsummrydata,date:{err:true,msg:'Please Select Date'}}) : setSelecedsummrydata({...selecedsummrydata,date:{err:false,msg:''}})

  //   if(err == false){
  //     jwtAuthAxios.post(`acc/paymentreceive`,{...value,DRAC:value?.bank.ACODE,CRAC:value?.partyID.ACODE,rate:value?.Rate ||jumboco?.curr?.Rate,DET_DATA:UPDOBJ,TYPE:"P"}).then((res) => {
  //       swal.fire({
  //         icon: 'success',
  //         text: res.data.message,
  //       });
  //     }).catch(e => {
  //       swal.fire({
  //         icon: 'error',
  //         text: 'Internal server Error',
  //       });
  //     })
  //   }    
  // }

  const handlePaymentValidaiton= async  ()=>{
    //alert('ok')
    let err=false;
    if(Object.keys(invoicePaidAMT).filter(s=>(invoicePaidAMT[s].paid_amt && invoicePaidAMT[s].paid_amt >0)||invoicePaidAMT[s]?.close_bill).length < 1){
      err=true;
      alert('Please Enter Bill Data')
      return
    }
    let UPDOBJ = (invoiceDataForUpdate || invoiceData)?.map(sInData => {
      let newObj = { ...invoicePaidAMT[`amt_paid_bill${sInData?.FL_BILL_NO}`], ...sInData }
      if(((sInData?.FFL_AMT2 - (sInData?.PAID_BILL)) - (invoicePaidAMT['amt_paid_bill' + sInData?.FL_BILL_NO]?.paid_amt || 0))?.toFixed(2) < 0){
        err=true;
        alert(sInData?.FL_BILL_NO+' Bill AMT is invalid')
      }
      // if((Math.ceil(newObj?.paid_amt) <= Math.ceil(sInData?.FFL_AMT2)) && (newObj?.paid_amt > 0)){
      // } else {
      //   err=true;
      //   setinvoicePaidAMT({...invoicePaidAMT,[`amt_paid_bill${sInData?.FL_BILL_NO}`]:{paid_amt:newObj?.paid_amt,err:true,hTEXT:"Invalid Amount"}})
      // }
      return newObj
    })
    value?.bank == null ? setSelecedsummrydata({...selecedsummrydata,bank:{err:true,msg:'Please Enter Bank Details'}}) : setSelecedsummrydata({...selecedsummrydata,bank:{err:false,msg:''}})
    value?.partyID == null ? setSelecedsummrydata({...selecedsummrydata,partyID:{err:true,msg:'Please Enter Party Details'}}) : setSelecedsummrydata({...selecedsummrydata,partyID:{err:false,msg:''}})
    value?.date == null ? setSelecedsummrydata({...selecedsummrydata,date:{err:true,msg:'Please Select Date'}}) : setSelecedsummrydata({...selecedsummrydata,date:{err:false,msg:''}})

    if(err == false){
      if(FRMVAL){
        jwtAuthAxios.post(`acc/paymentreceive/P/${FRMVAL?.master?.FL_TRANSNO}`, {...value,DRAC:value?.partyID.ACODE,CRAC:value?.bank.ACODE,rate:value?.Rate ||jumboco?.curr?.Rate,DET_DATA:UPDOBJ.filter(sd=> (sd.paid_amt && sd.paid_amt >0)||sd?.close_bill),TYPE:"P",PR_TYPE:"E"}).then((res) => {
          // fetchPartyInvoice()
          swal.fire({
            icon: 'success',
            text: res?.data?.message,
          });
        }).catch(alert)
      } else{
      jwtAuthAxios.post(`acc/paymentreceive`,{...value,DRAC:value?.partyID.ACODE,CRAC:value?.bank.ACODE,rate:value?.Rate ||jumboco?.curr?.Rate,DET_DATA:UPDOBJ.filter(sd=> (sd.paid_amt && sd.paid_amt >0)||sd?.close_bill),TYPE:"P",PR_TYPE:"E"}).then((res) => {
        fetchPartyInvoice()
        swal.fire({
          icon: 'success',
          text: res.data.message,
        });
      }).catch(e => {
        swal.fire({
          icon: 'error',
          text: 'Internal server Error',
        });
      })
    }
    }
    
    
  }
  return (<>
   
                  <Grid container spacing={2}>
                    <Grid item lg={5} xs={12}>
                    <FormControl fullWidth error={selecedsummrydata?.bank?.err} helperText={selecedsummrydata?.bank?.msg}>
                        <Autocomplete
                          value={value?.bank}
                          fullWidth
                          onChange={(event, newValue) => {
                            setValue({...value,bank:newValue});
                          }}
                          sx={{p:0}}
                          options={helperdata?.toData || []}
                          getOptionLabel={(option) => option?.ANAME || ''} // Specify the property to use as the display value
                          renderInput={(params) => (
                            <TextField {...params}  label="Please Select Bank" />
                          )}
                        />
                        </FormControl>
                      
                    </Grid>
                    <Grid item lg={4} xs={12}>
                    <TextField  fullWidth sx={{px:1}}   error={selecedsummrydata?.date?.err} helperText={selecedsummrydata?.date?.msg} type='date' name={'date'} onChange={e=>setValue({...value,date:e.target.value})} value={value?.date || ''} variant="outlined"/>
                    </Grid>
                    {/* <Grid item lg={1.5} xs={12}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="outlined-adornment-amount">Conversion Rate</InputLabel>
                        <OutlinedInput
                            // value={values.amount}
                            onChange={(e)=>setValue({...value,Rate:e.target.value > 0 ? e.target.value : null})}
                            type='number'
                            startAdornment={<InputAdornment position="start">{jumboco?.curr?.cd}</InputAdornment>}
                            value={value.Rate || jumboco?.curr?.Rate}
                            label="Conversion Rate"
                        />
                    </FormControl>
                    </Grid> */}
                    <Grid item lg={1.5} xs={12}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="outlined-adornment-amount">Conversion Rate</InputLabel>
                        <OutlinedInput
                            // value={values.amount}
                            onChange={e=>setValue({...value,FL_CURR_CODE:e.target.value})}
                            type='number'
                            startAdornment={<InputAdornment position="start">{jumboco?.curr?.cd}</InputAdornment>}
                            value={value?.Rate|| jumboco?.curr?.Rate}
                            label="Conversion Rate"
                        />
                    </FormControl>
                    </Grid>
                    {/* <Grid item lg={1.5} xs={12} disabled>
                    <FormControl name="FL_CURR_CODE" size="small" disabled  onChange={e=>setValue({...value,FL_CURR_CODE:e.target.value})} value={value?.FL_CURR_CODE} as={TextField} select label="Currency Type" fullWidth>
                      {currdata?.map((option) => (
                        <MenuItem key={option.FL_CURRENCY_ID} value={option.FL_CURRENCY_ID}>
                          {option.FL_CURRENCY_NAME}
                        </MenuItem>
                      ))}
                    </FormControl>
                    </Grid>
                    <Grid item lg={1.5} xs={12}>
                    <FormControl fullWidth>
                        
                        <TextField 
                            // value={values.amount}
                            onChange={(e)=>setValue({...value,Rate:e.target.value > 0 ? e.target.value : null})}
                            type='number' 
                            disabled
                            InputLabelProps={{ shrink: true }}
                            // startAdornment={<InputAdornment position="start">{jumboco?.curr?.cd}</InputAdornment>}
                            value={value.Rate}
                            label="Conversion Rate"
                        />
                    </FormControl>
                    </Grid>
                     */}
                    <Grid item lg={4} xs={12}>
                        <Autocomplete
                          value={value?.partyID}
                          fullWidth
                          onChange={(event, newValue) => {
                            setValue({...value,partyID:newValue});
                          }}
                          
                          options={helperdata?.fromData ||[]}
                          getOptionLabel={(option) => option?.ANAME || ''} // Specify the property to use as the display value
                          renderInput={(params) => (
                            <TextField {...params} label="Please Select Party" />
                          )}
                        />
                          
                    </Grid>
                   
                  
                  </Grid>
                  {/* </Form> */}

                  {(invoiceDataForUpdate || invoiceData)?.length > 0 && <TableContainer>
                    <Table  border={1} size='small' sx={{mt:2}}>
                      <TableHead>
                        <TableRow >
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Date</TableCell>
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}} >Invoice No</TableCell>
                          {/* <TableCell >Pcs</TableCell> */}
                          {/* <TableCell >Cts</TableCell> */}
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Currency</TableCell>
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Conv Rate</TableCell>
                          {/* <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Total AMT($)</TableCell> */}
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Total AMT</TableCell>
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Paid AMT</TableCell>
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>AMT</TableCell>
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Due AMT({jumboco?.curr?.cd})</TableCell>
                          {/* <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Ex Diff</TableCell> */}
                          <TableCell sx={{bgcolor:(theme)=> theme.palette.primary.main,color:(theme)=>theme.jumboComponents.JumboSearch.background}}>Close Bill</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                     {(invoiceDataForUpdate || invoiceData)?.map(indat => <TableRow key={indat?.FL_BILL_NO}>
                          <TableCell >{formatDate(indat?.FL_BILL_DATE)}</TableCell>
                          <TableCell >{indat?.FL_BILL_NO}</TableCell>
                          {/* <TableCell >{indat?.PCS}</TableCell> */}
                          {/* <TableCell >{indat?.CTS}</TableCell> */}
                          <TableCell >{indat?.CURR}</TableCell>
                          <TableCell >{indat?.FL_CONV_RATE}</TableCell>
                          {/* <TableCell >{indat?.FFL_AMT1?.toFixed(2)}</TableCell> */}
                          <TableCell >{indat?.FFL_AMT2?.toFixed(2)}</TableCell>
                          <TableCell >{indat?.PAID_BILL}</TableCell>
                          <TableCell sx={{p:0}} >
                            <TextField error={invoicePaidAMT['amt_paid_bill'+indat?.FL_BILL_NO]?.err} helperText={invoicePaidAMT['amt_paid_bill'+indat?.FL_BILL_NO]?.hTEXT || ''} fullWidth sx={{px:1,border:0}} type='number' inputProps={{ min: 0, max: Math.ceil(indat?.FFL_AMT2-indat?.PAID_BILL) }}  name={'amt_paid_bill'+indat?.FL_BILL_NO} onChange={e=>{Math.ceil(e.target.value) <= Math.ceil(indat?.FFL_AMT2-indat?.PAID_BILL) ? setinvoicePaidAMT({...invoicePaidAMT,[e.target.name]:{paid_amt:e.target.value}}):setinvoicePaidAMT({...invoicePaidAMT,[e.target.name]:{paid_amt:(indat?.FFL_AMT2-indat?.PAID_BILL).toFixed(2)}})}} value={invoicePaidAMT['amt_paid_bill'+indat?.FL_BILL_NO]?.paid_amt || 0} variant="standard"/>
                          </TableCell>
                          <TableCell >{((indat?.FFL_AMT2 - (indat?.PAID_BILL)) - (invoicePaidAMT['amt_paid_bill'+indat?.FL_BILL_NO]?.paid_amt || 0))?.toFixed(2)}</TableCell>
                        {/* <TableCell >{((value.Rate || jumboco?.curr?.Rate)- indat?.FL_CONV_RATE)?.toFixed(2)}</TableCell> */}
                        <TableCell>
                          <Tooltip title={`Due AMT is (${((indat?.FFL_AMT2 - (indat?.PAID_BILL)) - (invoicePaidAMT['amt_paid_bill'+indat?.FL_BILL_NO]?.paid_amt || 0))?.toFixed(2)})`}>
                            <Checkbox  name={'amt_paid_bill'+indat?.FL_BILL_NO} onClick={e=>setinvoicePaidAMT({...invoicePaidAMT,[e.target.name]:{...invoicePaidAMT[e.target.name],close_bill:e.target.checked}})} sx={{padding: '0',display: 'block',margin: '0 auto',width: 'fit-content'}}/>
                          </Tooltip>
                          </TableCell>
                        </TableRow>)}
                         <TableRow>
                          <TableCell colSpan={6}>Total</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>}
                 
                  <TextareaAutosize minRows={5} onInput={e=>setValue({...value,[e.target.name]:e.target.value})} name='narration' placeholder='NARRATION' defaultValue={value['narration']} style={{width:'100%',marginTop:'50px'}}></TextareaAutosize>
                  <LoadingButton disabled={(value.bank == null || value.partyID == null || value.date == null)  } onClick={handlePaymentValidaiton} variant="contained" sx={{mt:2,ml:'auto',display: 'block'}}>
                    Make Payment
                  </LoadingButton>
      </>
  )
};
const NormalPayment = ({FRMVAL}) => {
  const [value, setValue] = React.useState({bank:null,FL_CURR_CODE:2,date:null,Rate:null,narration:'',partyID:null});
  const [invoiceData, setinvoiceData] = React.useState(null);
  const [selectedinvoiceData, setSelectedinvoiceData] = React.useState(null);
  const [invoicePaidAMT, setinvoicePaidAMT] = React.useState({});
  const [currdata,setcurrdata]=useState([])
  const [selecedsummrydata,setSelecedsummrydata]=useState({})
  const [helperdata,sethelperdata]=useState({})
  const isMobile = isMobileDevice();
  const jumboco = useJumboAuth();
  const swal = useSwalWrapper();
  const {PID} = useParams();
  const init = async ()=>{
    await jwtAuthAxios.post('/acc/getleadgerdetail',{grpno:'1,2,3,4',tono:[21,22]}).then(res=>{
      sethelperdata(res.data)
    }).catch(e=>{
      swal.fire({
        icon:"error",
        text:e
      })
    })
    await jwtAuthAxios.get('master/helper?curr=1').then(RESDATA=>{
      setcurrdata(RESDATA.data.data.CURR)
    }).catch(e=>{
      swal.fire({
        icon:"error",
        text:e
      })
    })
    // PID&&  await jwtAuthAxios.get(`acc/getentrydetails?no=${PID}&type=P`).then(async res => {
    //   // setValue({bank:res,FL_CURR_CODE:2,date:null,Rate:null,narration:'',partyID:null})
    // })
  }
  useEffect(()=>{
    init()
  },[])
  useEffect(()=>{
    setValue({...value,Rate:jumboco?.curr?.Rate})
  },[jumboco?.curr])
  // const fetchPartyInvoice = useCallback(async()=>{if(value?.partyID){
  //   setinvoiceData([])
  //   setSelectedinvoiceData(null)
  //   setinvoicePaidAMT({})
  //    await jwtAuthAxios.get('/acc/getExpenseInvoice?party='+value?.partyID.P_CODE).then(res=>{
  //     setinvoiceData(res.data?.data)
  //   }).catch(e=>{
  //     setinvoiceData(null)
  //     setSelectedinvoiceData(null)
  //     swal.fire({
  //       icon:"error",
  //       text:e
  //     })
  //   })}},[value?.partyID])

    useEffect(() => {
      if (FRMVAL) {
        setValue({bank:FRMVAL?.CRAC,FL_CURR_CODE:FRMVAL?.master?.FL_CURRENCY,date:FRMVAL?.master?.FL_TRANS_DATE?.split('T')[0],Rate:FRMVAL?.master?.FL_CONV_RATE,narration:FRMVAL?.master?.FL_NARRATION?.split('Bill ')[0],CRAC:FRMVAL?.DRAC,paid_amt: FRMVAL?.master?.FL_PAID_AMT2});
        // formik.setValues({
        //   bank: FRMVAL?.CRAC,
        //   FL_CURR_CODE: FRMVAL?.master?.FL_CURRENCY,
        //   date: FRMVAL?.master?.FL_TRANS_DATE?.split('T')[0],
        //   Rate: FRMVAL?.master?.FL_CONV_RATE,
        //   narration: FRMVAL?.master?.FL_NARRATION?.split('Bill ')[0],
        //   CRAC: FRMVAL?.DRAC,
        //   ,
        // });
      }
    }, [FRMVAL]);


  // useEffect(async()=>{
  //   fetchPartyInvoice()
  // },[value?.partyID])
  // useEffect(async()=>{
  //   if(value?.partyID){
  //   setinvoiceData([])
  //   setSelectedinvoiceData(null)
  //    await jwtAuthAxios.get('/acc/getpartypurchaseinvoice?party='+value?.partyID.P_CODE).then(res=>{
  //     setinvoiceData(res.data?.data)
  //   }).catch(e=>{
  //     setinvoiceData(null)
  //     setSelectedinvoiceData(null)
  //     swal.fire({
  //       icon:"error",
  //       text:e
  //     })
  //   })}
  // },[value?.partyID])
  // const handlePaymentValidaiton= async  ()=>{
  //   //alert('ok')
  //   let err=false;
  //   if(Object.keys(invoicePaidAMT).filter(s=>(invoicePaidAMT[s].paid_amt && invoicePaidAMT[s].paid_amt >0)||invoicePaidAMT[s]?.close_bill).length < 1){
  //     err=true;
  //     alert('Please Enter Bill Data')
  //     return
  //   }
  //   let UPDOBJ= selectedinvoiceData?.map(sInData=>{
  //     let newObj = {...invoicePaidAMT[`amt_paid_bill${sInData?.FL_BILL_NO}`],...sInData}
  //     if((Math.ceil(newObj?.paid_amt) <= Math.ceil(sInData?.FFL_AMT2)) && (newObj?.paid_amt > 0)){
  //     } else {
  //       err=true;
  //       setinvoicePaidAMT({...invoicePaidAMT,[`amt_paid_bill${sInData?.FL_BILL_NO}`]:{paid_amt:newObj?.paid_amt,err:true,hTEXT:"Invalid Amount"}})
  //     }
  //     return newObj
  //   })
  //   value?.bank == null ? setSelecedsummrydata({...selecedsummrydata,bank:{err:true,msg:'Please Enter Bank Details'}}) : setSelecedsummrydata({...selecedsummrydata,bank:{err:false,msg:''}})
  //   value?.partyID == null ? setSelecedsummrydata({...selecedsummrydata,partyID:{err:true,msg:'Please Enter Party Details'}}) : setSelecedsummrydata({...selecedsummrydata,partyID:{err:false,msg:''}})
  //   value?.date == null ? setSelecedsummrydata({...selecedsummrydata,date:{err:true,msg:'Please Select Date'}}) : setSelecedsummrydata({...selecedsummrydata,date:{err:false,msg:''}})

  //   if(err == false){
  //     jwtAuthAxios.post(`acc/paymentreceive`,{...value,DRAC:value?.bank.ACODE,CRAC:value?.partyID.ACODE,rate:value?.Rate ||jumboco?.curr?.Rate,DET_DATA:UPDOBJ,TYPE:"P"}).then((res) => {
  //       swal.fire({
  //         icon: 'success',
  //         text: res.data.message,
  //       });
  //     }).catch(e => {
  //       swal.fire({
  //         icon: 'error',
  //         text: 'Internal server Error',
  //       });
  //     })
  //   }    
  // }
  const handlePaymentValidaiton= async  ()=>{
    //alert('ok')
    let err=false;
    // if(Object.keys(invoicePaidAMT).filter(s=>(invoicePaidAMT[s].paid_amt && invoicePaidAMT[s].paid_amt >0)||invoicePaidAMT[s]?.close_bill).length < 1){
    //   err=true;
    //   alert('Please Enter Bill Data')
    //   return
    // }
    // let UPDOBJ= invoiceData?.map(sInData=>{
    //   let newObj = {...invoicePaidAMT[`amt_paid_bill${sInData?.FL_BILL_NO}`],...sInData}
    //   // if((Math.ceil(newObj?.paid_amt) <= Math.ceil(sInData?.FFL_AMT2)) && (newObj?.paid_amt > 0)){
    //   // } else {
    //   //   err=true;
    //   //   setinvoicePaidAMT({...invoicePaidAMT,[`amt_paid_bill${sInData?.FL_BILL_NO}`]:{paid_amt:newObj?.paid_amt,err:true,hTEXT:"Invalid Amount"}})
    //   // }
    //   return newObj
    // })
    value?.bank == null ? setSelecedsummrydata({...selecedsummrydata,bank:{err:true,msg:'Please Enter Bank Details'}}) : setSelecedsummrydata({...selecedsummrydata,bank:{err:false,msg:''}})
    value?.CRAC == null ? setSelecedsummrydata({...selecedsummrydata,CRAC:{err:true,msg:'Please Enter Party Details'}}) : setSelecedsummrydata({...selecedsummrydata,CRAC:{err:false,msg:''}})
    value?.date == null ? setSelecedsummrydata({...selecedsummrydata,date:{err:true,msg:'Please Select Date'}}) : setSelecedsummrydata({...selecedsummrydata,date:{err:false,msg:''}})

    if(err == false){
      if(FRMVAL){
       await jwtAuthAxios.post(FRMVAL ? `acc/paymentreceive/P/${FRMVAL?.master?.FL_TRANSNO}` : `acc/paymentreceive`, { ...value, DRAC:value?.bank.ACODE,CRAC:value?.CRAC.ACODE, rate: value?.Rate || jumboco?.curr?.Rate, paid_amt: value.paid_amt, PR_TYPE: 'N', TYPE: "P" }).then((res) => {
          swal.fire({
            icon: 'success',
            text: res.data.message,
          });
        }).catch(alert);
      } else{

        await jwtAuthAxios.post(`acc/paymentreceive`,{...value,DRAC:value?.bank.ACODE,CRAC:value?.CRAC.ACODE,rate:value?.Rate ||jumboco?.curr?.Rate,paid_amt:value.paid_amt,PR_TYPE:'N',TYPE:"P"}).then((res) => {
        // fetchPartyInvoice()
        swal.fire({
          icon: 'success',
          text: res.data.message,
        });
      }).catch(e => {
        swal.fire({
          icon: 'error',
          text: 'Internal server Error',
        });
      })
    }
  }
    
    
  }
  return (<>
   
                  <Grid container spacing={2}>
                    <Grid item lg={5} xs={12}>
                    <FormControl fullWidth error={selecedsummrydata?.bank?.err} helperText={selecedsummrydata?.bank?.msg}>
                        <Autocomplete
                          value={value?.bank}
                          fullWidth
                          onChange={(event, newValue) => {
                            setValue({...value,bank:newValue});
                          }}
                          sx={{p:0}}
                          options={helperdata?.toData || []}
                          getOptionLabel={(option) => option?.ANAME || ''} // Specify the property to use as the display value
                          renderInput={(params) => (
                            <TextField {...params}  label="Select Bank" />
                          )}
                        />
                        </FormControl>
                      
                    </Grid>
                    <Grid item lg={4} xs={12}>
                    <TextField  fullWidth sx={{px:1}} error={selecedsummrydata?.date?.err} helperText={selecedsummrydata?.date?.msg} type='date' name={'date'} onChange={e=>setValue({...value,date:e.target.value})} value={value?.date || ''} variant="outlined"/>
                    </Grid>
                    {/* <Grid item lg={1.5} xs={12}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="outlined-adornment-amount">Conversion Rate</InputLabel>
                        <OutlinedInput
                            // value={values.amount}
                            onChange={(e)=>setValue({...value,Rate:e.target.value > 0 ? e.target.value : null})}
                            type='number'
                            startAdornment={<InputAdornment position="start">{jumboco?.curr?.cd}</InputAdornment>}
                            value={value.Rate || jumboco?.curr?.Rate}
                            label="Conversion Rate"
                        />
                    </FormControl>
                    </Grid> */}
                    <Grid item lg={1.5} xs={12}>
                    {/* <ButtonGroup variant="outlined"> */}
                    <FormControl name="FL_CURR_CODE" size="small" disabled  onChange={e=>setValue({...value,FL_CURR_CODE:e.target.value})} value={value?.FL_CURR_CODE} as={TextField} select label="Currency Type" fullWidth>
                      {currdata?.map((option) => (
                        <MenuItem key={option.FL_CURRENCY_ID} value={option.FL_CURRENCY_ID}>
                          {option.FL_CURRENCY_NAME}
                        </MenuItem>
                      ))}
                    </FormControl>
                    </Grid>
                    <Grid item lg={1.5} xs={12}>
                    <FormControl fullWidth>
                        {/* <InputLabel  htmlFor="outlined-adornment-amount">Conversion Rate</InputLabel> */}
                        <TextField 
                            // value={values.amount}
                            onChange={(e)=>setValue({...value,Rate:e.target.value > 0 ? e.target.value : null})}
                            type='number' disabled
                            InputLabelProps={{ shrink: true }}
                            // startAdornment={<InputAdornment position="start">{jumboco?.curr?.cd}</InputAdornment>}
                            value={value.Rate}
                            label="Conversion Rate"
                        />
                    </FormControl>
                    {/* </ButtonGroup> */}

                    </Grid>
                   <Grid item lg={4} xs={12}>
                      {/* {JSON.stringify(value?.bank)} */}
                      {/* {JSON.stringify(value?.CRAC)} */}
                    <FormControl fullWidth error={selecedsummrydata?.CRAC?.err} helperText={selecedsummrydata?.CRAC?.msg}>
                        <Autocomplete
                          value={value?.CRAC}
                          fullWidth
                          onChange={(event, newValue) => {
                            setValue({...value,CRAC:newValue});
                          }}     
                          sx={{p:0}}                     
                          options={helperdata?.grpleadgerAll ||[]}
                          getOptionLabel={(option) => option?.ANAME || ''}
                          renderInput={(params) => (
                            <TextField {...params} label="Select AC" />
                          )}
                        />
                        </FormControl>
                    </Grid>
                    <Grid item lg={4} xs={12}>
                    <FormControl fullWidth>
                        <TextField 
                            onChange={(e)=>setValue({...value,paid_amt:e.target.value})}
                            type='number'
                            InputLabelProps={{ shrink: true }}
                            value={value.paid_amt}
                            label="Amount"
                        />
                    </FormControl>
                    </Grid>
                  </Grid>
                  <TextareaAutosize minRows={5} onInput={e=>setValue({...value,[e.target.name]:e.target.value})} name='narration' placeholder='NARRATION' style={{width:'100%',marginTop:'50px'}} defaultValue={value['narration']}></TextareaAutosize>
                  <LoadingButton disabled={(value.bank == null || value.CRAC == null || value.date == null  ||value?.bank?.ACODE == value?.CRAC?.ACODE || value.paid_amt < 1)  } onClick={handlePaymentValidaiton} variant="contained" sx={{mt:2,ml:'auto',display: 'block'}}>
                    Make Payment
                  </LoadingButton>
      </>
  )
};
export const a11yProps = (index) => {
  return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
  };
};
const TABRECIPIENT = {E:1, P: 0, N: 2 }
 export const TabPanel = (props) => {
    const {children, value, index, ...other} = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Div sx={{p: 3}}>
                    <Typography>{children}</Typography>
                </Div>
            )}
        </div>
    );
  }; 


const PaymentModule=()=>{
 const theme = useTheme();
 const {PTYPE,PID} = useParams();
 const [value, setValue] = React.useState(TABRECIPIENT[PTYPE]||0);
 const [FRMVAL, setFRMVAL] = React.useState(null);
const jumbo= useJumboAuth()
const handleChange = (event, newValue) => {
    setValue(newValue);
};

const handleChangeIndex = (index) => {
    setValue(index);
};
useEffect(async () => {
PID && await jwtAuthAxios.get('acc/getentrydetails?no=' + PID + '&type=P').then(res =>
    setFRMVAL(res.data)).catch(alert);

}, []);
  return <Paper spacing={0}  style={{padding:0}}>
  <AppBar position="static">
  <Tabs
      value={value}
      onChange={handleChange}
      indicatorColor="secondary"
      textColor="inherit"
      variant="fullWidth"
      aria-label="full width tabs example"
      >
      <Tab disabled={PTYPE} label="Party Payment" {...a11yProps(0)} />
      <Tab disabled={PTYPE} label="Expense Payment" {...a11yProps(1)} />
      <Tab disabled={PTYPE} label="Normal Payment" {...a11yProps(2)} />
  </Tabs>
</AppBar>
<SwipeableViews 
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={value}
                    onChangeIndex={handleChangeIndex}
                >
                    <TabPanel  value={value} index={0} dir={theme.direction}>
                      <PartyPayment FRMVAL={FRMVAL}/>
                    </TabPanel>
                    <TabPanel  value={value} index={1} dir={theme.direction}>
                        <ExpensePayment FRMVAL={FRMVAL}/>
                    </TabPanel>
                    <TabPanel  value={value} index={2} dir={theme.direction}>
                        <NormalPayment FRMVAL={FRMVAL}/>
                    </TabPanel>
                </SwipeableViews>
    </Paper>
}
PaymentModule.Modulename = 'partyPayment';
export default PaymentModule;
